
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [{"enable-background":"new 0 0 227.406 227.406"},style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Capa_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 227.406 227.406","style":"enable-background:new 0 0 227.406 227.406;","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('g',[_c('path',{attrs:{"d":"M217.576,214.708l-65.188-67.794c16.139-15.55,26.209-37.355,26.209-61.484\r\n\t\tc0-47.106-38.323-85.43-85.43-85.43C46.06,0,7.737,38.323,7.737,85.43c0,47.106,38.323,85.43,85.43,85.43\r\n\t\tc17.574,0,33.924-5.339,47.52-14.474l66.077,68.719c1.473,1.531,3.439,2.302,5.407,2.302c1.87,0,3.743-0.695,5.197-2.094\r\n\t\tC220.354,222.441,220.447,217.693,217.576,214.708z M22.737,85.43c0-38.835,31.595-70.43,70.43-70.43\r\n\t\tc38.835,0,70.43,31.595,70.43,70.43s-31.595,70.43-70.43,70.43C54.332,155.859,22.737,124.265,22.737,85.43z"}}),_c('path',{attrs:{"d":"M131.415,77.93h-30.748V47.182c0-4.143-3.357-7.5-7.5-7.5c-4.143,0-7.5,3.357-7.5,7.5V77.93H54.918\r\n\t\tc-4.143,0-7.5,3.357-7.5,7.5s3.357,7.5,7.5,7.5h30.748v30.749c0,4.143,3.357,7.5,7.5,7.5c4.143,0,7.5-3.357,7.5-7.5V92.93h30.748\r\n\t\tc4.143,0,7.5-3.357,7.5-7.5S135.557,77.93,131.415,77.93z"}})]),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g')])
          )
        }
      }
    